import axios from 'axios';
import { FormEvent, useEffect, useState } from 'react';
import { GoogleLogin } from 'react-google-login';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { RouteComponentProps, useLocation, useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import google from '../../assets/icons/backOffice/google.svg';
import { Button } from '../../components/common/Button/Button';
import { InputBackOffice } from '../../components/common/InputBackoffice';
import Spinner from '../../components/common/Spinner';
import { ErrorToast } from '../../components/common/Toasts/Toasts';
import { validateEmail } from '../../helpers/helperFunctions';
import { removeUserFromLS } from '../../helpers/localstorage-helper';
import {
  DASHBOARD,
  LOGIN,
  LOGIN_TRAVELUTION,
  REFERRAL
} from '../../routes/routes';
import {
  continueToAffiliateTerms,
  logoutRemoveState,
  signIn,
  signInGoogle
} from '../../slices/auth-slice';

import { CaptionText } from '../../styles/FontStyles';
import { AuthLayoutTitle } from '../../styles/GlobalComponents';
import { colors } from '../../styles/GlobalStyles';

import { SocialButton } from './SocialButton';

const captchaId = process.env.REACT_APP_CAPTCHA_ID;
const earnBetRegisterUrl = process.env.REACT_APP_EARNBET_REGISTER_URL;
const earnBetLoginUrl = process.env.REACT_APP_EARNBET_LOGIN_URL;

type TParams = { id?: string; referralCode?: string };

const LoginEarnBet = ({ history, match }: RouteComponentProps<TParams>) => {
  const { loading } = useAppSelector((state) => state.auth);

  const { user } = useAppSelector((state) => state.auth.userInfo);

  const registerToEarnBet = async () => {
    try {
      const { data } = await axios.post(`/earnbet/onetime/generate`);

      window.location.href = `${earnBetRegisterUrl}/${data.data.token}/${user.id}`;
    } catch (e) {
      ErrorToast();
    }
  };

  const loginToEarnBet = async () => {
    try {
      const { data } = await axios.post(`/earnbet/onetime/generate`);

      window.location.href = `${earnBetLoginUrl}/${data.data.token}/${user.id}`;
    } catch (e) {
      ErrorToast();
    }
  };

  return (
    <div>
      {loading && <Spinner fullScreen={true} transparent />}

      <Button
        m='10px 0 20px 0'
        negative
        onClick={() => {
          loginToEarnBet();
        }}>
        Login to EarnBet
      </Button>

      <Button
        onClick={() => {
          registerToEarnBet();
        }}>
        Create EarnBet Account
      </Button>
    </div>
  );
};

export default LoginEarnBet;
